/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Dutch (Netherlands)
export default {
  'navigation.global-shortcuts.all-sites': 'Alle sites',
  'navigation.global-shortcuts.menu-expand-item.close-button-aria-label': 'Sluiten',
  'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': '(momenteel niet beschikbaar)',
  'navigation.global-shortcuts.sites': '{productName}-sites',
};
